var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddmoreIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_241_6509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2251 22.0342H0V53.2137H48.2251V22.0342Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0276 18.8057H48.2248V22.0351H32.1538L33.0276 18.8057Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2251 22.0352H0V53.2147H48.2251V22.0352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0276 18.8047H48.2248V22.0342H32.1538L33.0276 18.8047Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.56038 1.53222C7.44342 1.02818 7.44342 0.504045 7.56038 0C7.62268 0.250477 7.65189 0.50804 7.64724 0.766109C7.65101 1.02414 7.62182 1.28159 7.56038 1.53222Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12012 1.98153C9.19205 1.7337 9.29538 1.49609 9.4276 1.27448C9.55239 1.04883 9.70597 0.840358 9.88449 0.654297C9.81333 0.902403 9.70996 1.14011 9.57701 1.36134C9.45196 1.58683 9.2984 1.79527 9.12012 1.98153Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2478 3.14816C10.4335 2.96952 10.6414 2.81539 10.8663 2.68954C11.0867 2.55907 11.3224 2.45638 11.5681 2.38379C11.1917 2.73541 10.7402 2.99679 10.2478 3.14816Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6387 4.72699C10.8889 4.66631 11.1456 4.63713 11.403 4.64013C11.6611 4.63548 11.9187 4.66468 12.1692 4.72699C11.919 4.78756 11.6622 4.81674 11.4048 4.81385C11.1468 4.8176 10.8893 4.78841 10.6387 4.72699Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1887 6.28906C10.4365 6.36041 10.6741 6.46316 10.8958 6.59481C11.1209 6.72108 11.3293 6.87516 11.516 7.05344C11.0217 6.90174 10.568 6.64046 10.1887 6.28906Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01953 7.41406C9.19766 7.60086 9.35174 7.80921 9.47816 8.03425C9.61036 8.25525 9.7137 8.49228 9.78564 8.73956C9.43252 8.36194 9.17046 7.90854 9.01953 7.41406Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44232 7.80469C7.55928 8.30873 7.55928 8.83287 7.44232 9.33691C7.38001 9.08643 7.35081 8.82887 7.35546 8.5708C7.35169 8.31277 7.38088 8.05532 7.44232 7.80469Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88229 7.35547C5.81036 7.6033 5.70703 7.84091 5.57481 8.06251C5.45022 8.28882 5.29662 8.49789 5.11792 8.68444C5.18985 8.43606 5.29319 8.19788 5.42541 7.97565C5.55164 7.75093 5.70509 7.54263 5.88229 7.35547Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75643 6.18652C4.56975 6.3648 4.36139 6.51888 4.13625 6.64515C3.9151 6.7787 3.67739 6.88267 3.4292 6.95437C3.80831 6.60196 4.26196 6.33951 4.75643 6.18652Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36548 4.60955C4.11469 4.67012 3.85735 4.6993 3.59936 4.69641C3.34141 4.70075 3.08396 4.67214 2.83325 4.61129C3.08382 4.5493 3.34126 4.51952 3.59936 4.52269C3.85735 4.5198 4.11469 4.54898 4.36548 4.60955Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8138 3.05051C4.56609 2.97824 4.32852 2.87492 4.10675 2.74302C3.88203 2.61679 3.67374 2.46334 3.48657 2.28613C3.73433 2.35748 3.97194 2.46023 4.19361 2.59188C4.41932 2.71727 4.62779 2.87144 4.8138 3.05051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98489 1.93194C5.80625 1.74621 5.65212 1.53837 5.52626 1.31349C5.39271 1.09235 5.28875 0.854638 5.21704 0.606445C5.39611 0.792453 5.55027 1.00092 5.67566 1.22663C5.80772 1.44793 5.9116 1.68487 5.98489 1.93194Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8324 6.82715H13.467V47.0888H44.8324V6.82715Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8304 47.089L13.4667 47.1446H13.4111V47.089L13.3816 6.82731V6.74219H13.4667L44.8304 6.7613H44.8964V6.82731L44.8304 47.089ZM44.8304 47.089L44.7661 6.82731L44.8304 6.89159L13.4667 6.91243L13.5518 6.82731L13.5206 47.089L13.4667 47.0351L44.8304 47.089Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 15.4317L29.1485 15.4004L41.3994 15.4317L29.1485 15.4629L16.8977 15.4317Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 16.4307L29.1485 16.3994L41.3994 16.4307L29.1485 16.462L16.8977 16.4307Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 17.4317L29.1485 17.4004L41.3994 17.4317L29.1485 17.4612L16.8977 17.4317Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 18.4307L29.1485 18.3994L41.3994 18.4307L29.1485 18.462L16.8977 18.4307Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 19.4287L29.1485 19.3975L41.3994 19.4287L29.1485 19.46L16.8977 19.4287Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 20.4278L29.1485 20.3965L41.3994 20.4278L29.1485 20.459L16.8977 20.4278Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 21.4268L29.1485 21.3955L41.3994 21.4268L29.1485 21.458L16.8977 21.4268Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 22.425L29.1485 22.3955L41.3994 22.425L29.1485 22.4563L16.8977 22.425Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 23.4258L29.1485 23.3945L41.3994 23.4258L29.1485 23.4553L16.8977 23.4258Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 24.4248L29.1485 24.3936L41.3994 24.4248L29.1485 24.4544L16.8977 24.4248Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 25.4239L29.1485 25.3926L41.3994 25.4239L29.1485 25.4551L16.8977 25.4239Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 26.4229L29.1485 26.3916L41.3994 26.4229L29.1485 26.4541L16.8977 26.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 27.4219L29.1485 27.3906L41.3994 27.4219L29.1485 27.4532L16.8977 27.4219Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 28.4211L29.1485 28.3916L41.3994 28.4211L29.1485 28.4524L16.8977 28.4211Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 29.4202L29.1485 29.3906L41.3994 29.4202L29.1485 29.4514L16.8977 29.4202Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3469 26.3916H19.488V30.5852H21.3469V26.3916Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7934 24.1562H22.9346V30.5857H24.7934V24.1562Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2402 21.6504H26.3813V30.5849H28.2402V21.6504Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6884 20.5752H29.8296V30.585H31.6884V20.5752Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1352 18.6602H33.2764V30.5861H35.1352V18.6602Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5817 16.7656H36.7229V30.5852H38.5817V16.7656Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5614 14.7314L17.6101 18.694L17.6431 22.6584C17.6657 25.3007 17.6726 27.943 17.6778 30.5853L17.5614 30.4706H23.5218L29.4805 30.4845L35.4408 30.5227L41.3995 30.5905L35.4408 30.6582L29.4805 30.6964L23.5218 30.7103H17.5614H17.4468V30.5957C17.4468 27.9534 17.4572 25.3111 17.4798 22.6688L17.5145 18.7045L17.5614 14.7314Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3469 31.4229H19.488V31.5914H21.3469V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7934 31.4229H22.9346V31.5914H24.7934V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2402 31.4229H26.3813V31.5914H28.2402V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6884 31.4229H29.8296V31.5914H31.6884V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1352 31.4229H33.2764V31.5914H35.1352V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5817 31.4229H36.7229V31.5914H38.5817V31.4229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6983 26.9223C20.6062 26.9083 21.5123 26.8392 22.4118 26.7156C23.3106 26.6007 24.203 26.4401 25.0854 26.2344C26.8518 25.8369 28.5654 25.2335 30.1911 24.4364C31.8205 23.6512 33.3236 22.6271 34.6505 21.398L34.9024 21.1704L35.1404 20.9289L35.6146 20.4443C35.9065 20.0968 36.2209 19.7737 36.4833 19.4019C37.0454 18.6876 37.554 17.9327 38.0051 17.1436H38.0207C37.1996 18.7786 36.1077 20.2629 34.7912 21.5335C34.1347 22.1723 33.4244 22.7535 32.6683 23.2707C31.9165 23.793 31.1261 24.2576 30.304 24.6605C26.9969 26.2445 23.3603 27.0186 19.6948 26.9189L19.6983 26.9223Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.535 18.4458L38.2779 18.51L37.9617 17.2419L36.7196 17.6501L36.6379 17.3982L38.1493 16.9014L38.535 18.4458Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3731 37.8545H41.9241V36.8209H16.3731V37.8545Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3749 40.4639H30.759V39.4302H16.3749V40.4639Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9565 12.3096L36.3406 12.3096V11.2759L21.9565 11.2759V12.3096Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8666 44.9345L7.50122 44.9189L7.52207 4.65723L30.8094 4.66939L38.8822 12.3444L38.8666 44.9345Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.8666 44.9345L7.50122 44.9189L7.52207 4.65723L30.8094 4.66939L38.8822 12.3444L38.8666 44.9345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8094 4.66992L38.8822 12.3449L30.8059 12.3415L30.8094 4.66992Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.8094 4.66992L38.8822 12.3449L30.8059 12.3415L30.8094 4.66992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5606 12.4941H27.9988V11.4605H10.5606V12.4941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5787 15.0563L28.0168 15.0654L28.0174 14.0318L10.5792 14.0227L10.5787 15.0563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5748 17.6657L28.0129 17.6748L28.0135 16.6412L10.5753 16.632L10.5748 17.6657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5729 20.2737L36.1238 20.2871L36.1243 19.2535L10.5734 19.2401L10.5729 20.2737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5726 22.886L36.1235 22.8994L36.1241 21.8658L10.5731 21.8524L10.5726 22.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5719 25.4944L36.1228 25.5078L36.1233 24.4742L10.5724 24.4608L10.5719 25.4944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5699 28.1038L36.1208 28.1172L36.1214 27.0835L10.5705 27.0702L10.5699 28.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5677 30.7142L36.1187 30.7275L36.1192 29.6939L10.5683 29.6805L10.5677 30.7142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5675 33.3245L36.1184 33.3379L36.1189 32.3043L10.568 32.2909L10.5675 33.3245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.567 35.9329L36.1179 35.9463L36.1185 34.9126L10.5675 34.8993L10.567 35.9329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.565 38.5403L36.116 38.5537L36.1165 37.5201L10.5656 37.5067L10.565 38.5403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5628 41.1507L36.1138 41.1641L36.1143 40.1304L10.5634 40.117L10.5628 41.1507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.112793 53.2139H48.3378L51.6559 24.6211H3.43087L0.112793 53.2139Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.801 21.6592H51.9999L51.6559 24.6211H35.585L36.801 21.6592Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3363 50.9167C44.5091 50.9167 47.0812 48.3446 47.0812 45.1717C47.0812 41.9989 44.5091 39.4268 41.3363 39.4268C38.1634 39.4268 35.5913 41.9989 35.5913 45.1717C35.5913 48.3446 38.1634 50.9167 41.3363 50.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9269 41.6221H40.7473V48.7186H41.9269V41.6221Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8855 45.7626V44.583H37.789V45.7626H44.8855Z",
    fill: "#502BAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_6509",
    x: 0,
    y: 0,
    width: 61,
    height: 61.2148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_6509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_6509",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmoreIco);
export default __webpack_public_path__ + "static/media/addmoreIco.7973d740d493bc66d4c175684d634f4d.svg";
export { ForwardRef as ReactComponent };